import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export function RecordFound(props) {
  const formatTime = (value) => {
    const dateTime = new Date(value);
    let date = dateTime.getDate().toString().padStart(2, '0');
    let month = (dateTime.getMonth() + 1).toString().padStart(2, '0');
    let year = dateTime.getFullYear();
    const formattedTime = `${year}-${month}-${date}`;
    return value ? formattedTime : '';
  };

  return (
    <Stack spacing={2} padding={2}>
      <Stack direction='row' spacing={1} justifyContent='center' alignItems='baseline'>
        <Typography sx={{ fontWeight: 900 }}>
          Serial No:
        </Typography>
        <Typography sx={{ color: '#AF270A', fontWeight: 900 }}>
          {props?.data[0]?.transaction_id}
        </Typography>
      </Stack>
      <Typography sx={{ color: '#AF270A', fontWeight: 700 }}>
        {props?.data[0]?.reference1 || `{props?.data[0]?.reference1}`}
      </Typography>
      <Typography>အတွက်</Typography>
      <Typography sx={{ color: '#AF270A', fontWeight: 700 }}>
        {props.data[0]?.name ? props?.data[0]?.name : `{props?.data[0]?.name}`}
      </Typography>
      <Typography>က</Typography>
      <Typography sx={{ color: '#AF270A', fontWeight: 700 }}>{`${
        props?.data[0]?.reference2 ? props?.data[0]?.reference2 : '{props?.data[0]?.reference2}'
      }`}</Typography>
      <Typography sx={{ fontSize: 'small' }}>ထောက်ပို့ကြောင်း အတည်ပြုပါသည်။</Typography>
      <Typography variant='overline' fontSize='0.6rem'>
        Issued Date: {formatTime(props?.data[0]?.transactiontime)}
      </Typography>
    </Stack>
  );
}
